/** Max wait before idle callback runs when the browser stays busy (ms). */
const IDLE_CALLBACK_TIMEOUT_MS = 2000;

/** Fallback delay when `requestIdleCallback` is unavailable (ms). */
const FALLBACK_DEFER_MS = 1;

/**
 * Runs work after login bootstrap so it does not compete with profile/theme and first paint.
 * Prefer `requestIdleCallback`; falls back to a short timeout in tests and older browsers.
 */
export function runAfterLoginBootstrap(callback: () => void): () => void {
  if (typeof requestIdleCallback === "function") {
    const idleId = requestIdleCallback(() => callback(), { timeout: IDLE_CALLBACK_TIMEOUT_MS });
    return () => cancelIdleCallback(idleId);
  }

  const timeoutId = window.setTimeout(callback, FALLBACK_DEFER_MS);
  return () => clearTimeout(timeoutId);
}
